export default __webpack_public_path__ + "static/media/09.2f627884.jpg";